var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "jade-status-tracker__content",
      class: _vm.computedClassList,
    },
    [
      _c(
        "jade-text",
        {
          staticClass: "jade-status-tracker__label",
          attrs: {
            weight: _vm.computedLabelWeight,
            color: "current-color",
            "data-testid": "text-label",
            variant: "text-large",
          },
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm.description
        ? _c(
            "jade-text",
            {
              attrs: {
                color: "medium",
                "data-testid": "text-description",
                variant: "text-medium",
                weight: "regular",
              },
            },
            [_vm._v(_vm._s(_vm.description))]
          )
        : _vm._e(),
      _vm.isValidLink
        ? _c(
            "jade-link",
            {
              attrs: {
                href: _vm.$sanitize(_vm.link.href),
                external: _vm.link?.external,
                target: _vm.link?.target,
                as: "a",
                variant: "brand",
                weight: "semibold",
                "data-testid": "jade-link",
                rel: "noopener noreferrer",
              },
            },
            [_vm._v(_vm._s(_vm.link.label))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }